import { useEffect } from 'react';

import { useSelector } from 'react-redux';
import userflow from 'userflow.js';

import { IRole } from '../../@types/user';
import { Constants } from '../../helpers/Auth';
import { RootState } from '../../store';

const UserFlowInitializer = () => {
  const currentUser = useSelector((state: RootState) => state.users.current);
  const userFlowSecret = useSelector((state: RootState) => state.users.userFlowSignature);
  const { identity, signature } = userFlowSecret ?? {};
  const userFlowKey = Constants.userFlowKey;

  useEffect(() => {
    if (currentUser && userFlowSecret) {
      userflow.init(userFlowKey);
      userflow.identify(
        identity,
        {
          name: `${currentUser.givenName} ${currentUser.lastName}`,
          email: currentUser.email,
          accountType: currentUser.roles.map((role: IRole) => role.roleName).join(', '),
        },
        { signature },
      );
    }
  }, [currentUser, userFlowKey, userFlowSecret]);

  return null;
};

export default UserFlowInitializer;
